import { validationMessages } from './validationMessages.schema';

export default {
  type: 'object',
  properties: {
    code: {
      title: 'Kod',
      type: 'string',
      fieldRequired: true
    },
    description: {
      title: 'Opis',
      type: 'string',
      fieldRequired: false
    },
    entityType: {
      title: 'Typ Encji',
      type: 'string',
      fieldRequired: false
    },
    entityId: {
      title: 'Identyfikator encji',
      type: 'string',
      fieldRequired: false
    },
    value: {
      title: 'Wartość',
      type: 'string',
      fieldRequired: true,
      calc: {
        when: "this.valueType === 'DATE' && this.date",
        func: 'this.date'
      }
    },
    date: {
      calc: {
        when: "this.valueType === 'DATE' && !this.date",
        func: 'this.value'
      },
      computed: true,
      fieldRequired: "this.valueType === 'DATE'",
      format: 'date',
      title: 'Wartość',
      type: 'string'
    },
    valueType: {
      title: 'Typ wartości',
      type: 'string',
      fieldRequired: false
    },
    groupId: {
      title: 'Identyfikator grupy',
      type: 'number',
      fieldRequired: false
    }
  },
  allOf: [validationMessages]
};
